import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';

export function compareFoldersBySize(a: BaseFolderType, b: BaseFolderType) {
    // ExtendedProperty[0] is the size of the folder. i.e 10MB, Value gives the size in bytes.
    return b.ExtendedProperty[0].Value - a.ExtendedProperty[0].Value;
}
